/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { IconBtn, IconGG, MainLogo, WebLayout, WhatsAppButton } from '../../components';
import { ContactForm } from '../../components/Landing/Shared';
import { sendContactFormRequest } from '../../requests/utils';
import { sendAlert } from '../../actions/utils';
import SuccessModal from '../../components/Landing/Shared/SuccessModal';
import useGetRoleByRoute from '../../hooks/useGetRoleByRoute';

const BrokerContact = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const { type } = useGetRoleByRoute();

  const handleSubmit = values => {
    sendContactFormRequest({
      dispatch,
      params: {
        ...values,
        type: 'broker_contact'
      },
      successCallback: result => {
        dispatch(sendAlert({ kind: 'success', message: result.data.message }));
        setShowSuccessModal(true);
      }
    });
  };

  const goBack = () => {
    history.goBack();
  };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, []);

  return (
    <WebLayout type="broker">
      <div className={`landing-form landing-form-${type}`}>
        <IconBtn onClick={goBack} variant="transparent" className="login-navbar--back-btn white back-btn">
          <IconGG icon="chevron-left" />
          <span className="login-navbar--back-btn__text ">Volver</span>
        </IconBtn>
        {!showSuccessModal && (
          <div className={`form-container form-${type}`}>
            <MainLogo type="dark" />
            <h5 className="text-center font-weight-900 text-dark-blue">
              ¡Felicitaciones! Has dado el primer paso para llevar tu operación al siguiente nivel
            </h5>
            <p className="text-center font-weight-bold mt-2">Déjanos tus datos y te contactaremos lo antes posible.</p>
            <ContactForm formRequest={handleSubmit} buttonText="Solicitar" />
          </div>
        )}
        {showSuccessModal && <SuccessModal setShowSuccessModal={setShowSuccessModal} />}
        <WhatsAppButton />
      </div>
    </WebLayout>
  );
};

export default BrokerContact;
